export default {
	er_cover_default_title: 'Revisão de desempenho',
	er_page_success_metrics: 'O que mudou neste mês',
	er_page_success_metrics_range: 'O que mudou neste período',
	er_page_success_metrics_week: 'O que mudou nesta semana',
	er_page_comparison: 'Resumo comparativo',
	er_page_period_summary: 'Resumo do mês',
	er_page_period_summary_range: 'Resumo do período',
	er_page_period_summary_week: 'Resumo da semana',
	er_page_each_month: 'Cada mês',
	er_page_rooms: 'Salas',
	er_rooms_note: 'Cada sala em {month}, melhor pontuação primeiro.',
	er_page_shift_comparison: 'Comparação por turno',
	er_page_shift_summary: 'Por turno',
	er_page_response_time: 'Tempo médio de resposta (min)',
	er_page_avg_score: 'Pontuação de experiência',
	er_page_complaints_vs_visits: 'Reclamações vs visitas',
	er_page_performance_trends: 'Tendências de desempenho',
	er_page_complaint_drivers: 'Motivos de reclamação',

	er_board_working: 'Melhorou face a {month}',
	er_board_attention: 'Precisa de atenção face a {month}',
	er_board_empty: 'Não há mudanças relevantes neste mês.',
	er_board_empty_range: 'Não há mudanças relevantes neste período.',
	er_board_empty_week: 'Não há mudanças relevantes nesta semana.',
	er_findings_intro: 'Comparado com {month}. Só são mostradas mudanças relevantes.',
	er_verdict_improved: 'Melhorou',
	er_verdict_watch: 'Precisa de atenção',

	er_col_metric: 'Métrica',
	er_col_avg: 'Média acumulada no ano',
	er_col_lifetime_avg: 'Média desde o início',
	er_comparison_note: 'A média acumulada no ano é o valor de janeiro até {month}.',
	er_lifetime_note: 'A média desde o início é o valor mensal desde o primeiro dia com dados até {month}.',
	er_comparison_note_week: 'A semana do relatório é comparada com a semana anterior selecionada.',
	er_period_only_note: 'Os números referem-se apenas a {month}.',
	er_each_month_note: 'Cada mês do período selecionado. Um mês sem dados fica em branco.',
	er_col_inc_dec: 'Var.',
	er_col_complaint: 'Reclamação',
	er_col_qty: 'Qtd',
	er_total: 'Total',

	er_metric_avg_score: 'Pontuação de experiência',
	er_metric_avg_response_time: 'Tempo médio de resposta',
	er_metric_cleaner_arrivals: 'Limpezas Realizadas',
	er_metric_supervisor_inspections: 'Inspeções de supervisor',
	er_metric_complaints_vs_visits_pct: 'Reclamações vs. visitas (%)',
	er_metric_complaints: 'Reclamações',
	er_metric_customer_visits: 'Visitas',
	er_metric_expired_slas: 'SLAs expirados',
	er_unit_min: 'min',
	er_stat_expected_sla: 'SLA esperado',
	er_stat_vs_minutes: 'vs {value} em {month}',
	er_stat_vs_count: 'vs {value} em {month}',
	er_label_complaints: 'Reclamações',
	er_label_visits: 'Visitas',
	er_label_complaints_per_visits: 'Reclamações / visitas',
	er_chart_ratio: 'Proporção reclamações/visitas',
	er_chart_ytd_window: 'De janeiro até {month}.',
	er_cv_formula: 'Reclamações divididas pelas visitas aos sanitários, em porcentagem: ({complaints} ÷ {visits}) × 100 = {ratio}% em {month}.',
	er_export_kpis_title: 'O que o relatório inclui',
	er_export_kpis_desc: 'Tudo isto entra no relatório. Desligue um para o deixar de fora.',
	er_export_select_all: 'Selecionar tudo',
	er_export_clear_all: 'Limpar tudo',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Período do relatório',
	er_export_grain: 'Por',
	er_export_grain_month: 'Mês',
	er_export_grain_week: 'Semana',
	er_export_week_starts: 'A semana começa em',
	er_export_week_starts_sunday: 'domingo',
	er_export_week_starts_monday: 'segunda-feira',
	er_export_report_month: 'Mês do relatório',
	er_export_from_month: 'De',
	er_export_to_month: 'Até',
	er_export_period_note_range: 'O relatório soma cada mês do início ao fim. Com a comparação ligada, usa o período anterior com a mesma duração. Os valores do ano até à data continuam de janeiro até ao mês final.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'O período anterior com a mesma duração.',
	er_export_report_week: 'Semana do relatório',
	er_export_compare_month: 'Comparar com',
	er_export_shift: 'Turno',
	er_export_shift_all: 'Todos os turnos',
	er_export_no_shifts: 'Este local não tem turnos ativos.',
	er_export_render_failed: 'Não foi possível gerar o relatório corretamente, por isso ele não foi baixado. Atualize a página e tente novamente.',
	er_export_comparison: 'Comparação',
	er_export_include_previous: 'Incluir o período anterior',
	er_export_comparison_on: 'Ativada',
	er_export_comparison_off: 'Desativada',
	er_export_no_previous_data: 'Não há dados anteriores a este período, por isso não há com que comparar.',
	er_export_compare_previous: 'Mês anterior',
	er_export_compare_previous_week: 'Semana anterior',
	er_export_compare_last_year: 'Mesmo mês do ano passado',
	er_export_no_periods: 'Este local precisa de pelo menos um mês de dados para exportar um relatório.',
	er_export_no_periods_week: 'Este local precisa de pelo menos uma semana de dados para exportar um relatório.',
	er_export_period_note: 'Só são listados meses com dados. Os valores do ano até à data vão sempre de janeiro ao mês do relatório.',
	er_export_period_note_week: 'Só são listadas semanas com dados. A comparação é sempre com uma semana anterior.',
	er_export_period_note_single_week: 'Só são listadas as semanas com dados.',

	er_find_response_time_title: 'Tempo médio de resposta',
	er_find_response_time_change:
		'Mudou de {previous} para {current} minutos ({change}).',
	er_find_avg_score_title: 'Pontuação de experiência',
	er_find_score_eased: 'Desceu de {previous} para {current}.',
	er_find_score_improved: 'Subiu de {previous} para {current}.',
	er_find_score_ytd_inline: 'Coincide com a média do ano ({ytd}).',
	er_find_score_ytd_inline_range: 'Igual à média de janeiro até {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Média do ano: {ytd}.',
	er_find_score_ytd_against_range: 'Média de janeiro até {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Proporção reclamações/visitas',
	er_find_complaints_ratio_improved:
		'Melhorou de {previous} para {current}.',
	er_find_complaints_ratio_rose: 'Alterou de {previous} para {current}.',

	er_nar_cv_year_improved:
		'As reclamações em comparação às visitas aos sanitários melhoraram de {from} para {to} no ano.',
	er_nar_cv_year_rose: 'As reclamações em comparação às visitas aos sanitários subiram de {from} para {to} no ano.',
	er_nar_cv_moved: 'As reclamações em comparação às visitas aos sanitários passaram de {previous} para {current}.',
	er_nar_cv_current: 'As reclamações em comparação às visitas aos sanitários estão em {current}.',
	er_nar_types_total: 'Total de reclamações {total}.',
	er_nar_types_1: 'Principal reclamação: {a} ({ap}%).',
	er_nar_types_2: 'Principal reclamação: {a} ({ap}%), seguida de {b} ({bp}%).',
	er_nar_types_3: 'Principal reclamação: {a} ({ap}%), seguida de {b} ({bp}%) e {c} ({cp}%).',
	er_find_rooms_slowest: 'Salas com o maior tempo de resposta neste mês: {rooms}.',
	er_find_rooms_slowest_range: 'Salas com o maior tempo de resposta neste período: {rooms}.',
	er_find_rooms_slowest_week: 'Salas com o maior tempo de resposta nesta semana: {rooms}.',
	er_find_rooms_lowest_score: 'Salas com pior pontuação neste mês: {rooms}.',
	er_find_rooms_lowest_score_range: 'Salas com a pontuação mais baixa neste período: {rooms}.',
	er_find_rooms_lowest_score_week: 'Salas com pior pontuação nesta semana: {rooms}.',

	er_find_so_what_ratio: 'A maior parte da mudança veio de {rooms}.',
	er_find_so_what_type: 'Principal reclamação: {name} ({percent}%).',
	er_hot_slowest: 'Salas com o maior tempo de resposta',
	er_hot_expired_slas: 'Salas que excederam o SLA',
	er_hot_ratio: 'Salas com a maior alteração na taxa de reclamações',
	er_hot_top_type: 'Salas com mais reclamações de "{name}"',
	er_hot_col_room: 'Sala',
	er_col_response: 'Resposta',
	er_col_cleaners: 'Limpeza',
	er_col_score: 'Pontuação',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Taxa',
	er_hot_col_change: 'Variação',
	er_hot_col_count: 'Qtd',
	er_hot_empty: 'Sem destaques ao nível da sala neste mês.',
	er_hot_empty_range: 'Sem destaques ao nível da sala neste período.',
	er_hot_empty_week: 'Sem destaques ao nível da sala nesta semana.',
	er_cover_highlights: 'Este mês',
	er_cover_highlights_range: 'Este período',
	er_cover_highlights_week: 'Esta semana',
	er_cover_score_rose: 'A pontuação de experiência subiu.',
	er_cover_score_eased: 'A pontuação de experiência desceu.',
	er_cover_response_improved: 'O tempo de resposta melhorou.',
	er_cover_response_slowed: 'O tempo de resposta aumentou.',
	er_cover_ratio_fell: 'As reclamações face às visitas desceram.',
	er_cover_ratio_rose: 'As reclamações face às visitas subiram.',
	er_export_pdf: 'PDF do painel',
	er_export_executive: 'Relatório executivo',
	'executive-report': 'Relatório executivo',
	er_export_csv: 'CSV',
	er_export_status_title: 'A criar o relatório',
	er_export_status_fetch: 'A carregar os números',
	er_export_status_layout: 'A preparar as páginas',
	er_export_status_page: 'Página {page} de {total}',
	er_footer_copyright: 'Este relatório foi gerado através do sistema BuzzzTech.',
	er_contact_line: 'Tem perguntas ou quer explorar os dados em mais detalhe? Fale com a equipe de Customer Success da BuzzzTech em {email} ou {phone}.',
};
